import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSidebarCalendar = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.794 1a.75.75 0 0 1 .75.75v.848c1.46.1 2.673.6 3.531 1.46.937.941 1.43 2.294 1.425 3.917v9.123c0 3.332-2.116 5.402-5.521 5.402H7.521C4.116 22.5 2 20.401 2 17.022V7.973c0-3.143 1.887-5.16 4.965-5.375V1.75a.75.75 0 0 1 1.5 0v.829h6.578V1.75a.75.75 0 0 1 .75-.75M20 9.904H3.5v7.118C3.5 19.588 4.928 21 7.521 21h8.458C18.572 21 20 19.614 20 17.098zm-3.799 6.292a.75.75 0 0 1 0 1.5.754.754 0 0 1-.754-.75c0-.414.331-.75.745-.75zm-4.437 0a.75.75 0 0 1 0 1.5.754.754 0 0 1-.754-.75c0-.414.33-.75.745-.75zm-4.447 0a.75.75 0 0 1 0 1.5.755.755 0 0 1-.755-.75c0-.414.332-.75.746-.75zM16.2 12.31a.75.75 0 0 1 0 1.5.754.754 0 0 1-.754-.75c0-.414.331-.75.745-.75zm-4.437 0a.75.75 0 0 1 0 1.5.754.754 0 0 1-.754-.75c0-.414.33-.75.745-.75zm-4.447 0a.75.75 0 0 1 0 1.5.755.755 0 0 1-.755-.75c0-.414.332-.75.746-.75zm7.726-8.231H8.465v.962a.75.75 0 0 1-1.5 0v-.94C4.725 4.29 3.5 5.649 3.5 7.974v.431H20v-.43c.004-1.236-.328-2.196-.987-2.856-.578-.58-1.424-.927-2.469-1.016v.939a.75.75 0 0 1-1.5 0z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSidebarCalendar);
export default ForwardRef;
